import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext";
import { useEffect, useState } from "react";

import useApi from "../../../hooks/useApi";
const ModalAddMeta = ({ updateData }) => {
    const api = useApi();


    const { closeModal } = useModal();

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const [usuarios, setUsuarios] = useState([]);
    const [tiposChecklist, setTiposChecklist] = useState([]);

    const getValues = async () => {

        setLoading(true);

        try {
            const [usuariosRes, tiposRes] = await Promise.all([
                api.get("/Painel/API/Checklist/GetUsuarios/"),
                api.get("/Painel/API/Checklist/GetTipos/")
            ])

            setUsuarios(usuariosRes.data);
            setTiposChecklist(tiposRes.data);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        getValues();
    }, []);

    const [formValues, setFormValues] = useState({
        usuario: [],
        tipoChecklist: [],
        metaSemanal: ""
    })

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);

        try {
            const formData = new FormData();

            const usuariosIds = formValues.usuario.map(u => u.value);
            const tiposIds = formValues.tipoChecklist.map(t => t.value);

            formData.append('usuario', JSON.stringify(usuariosIds));
            formData.append('tipo_checklist', JSON.stringify(tiposIds));
            formData.append('meta_semanal', formValues.metaSemanal);

            const { data } = await api.post(
                "/Painel/API/Checklist/SaveMeta/",
                formData,
                { withCredentials: true }
            );

            closeModal();
            updateData();
        } catch (e) {
            console.error(e);
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <Overlay state={true} >
                <Modal size="md" header={true} close={closeModal} >
                    <Formulario onSubmit={handleSubmit} >
                        <FormComp
                            title="USUÁRIO"
                            type="multiselect"
                            placeholder="SELECIONE..."
                            options={usuarios.map(obj => ({
                                value: obj.id,
                                label: obj.usuario
                            }))}
                            mapped={true}
                            valor={formValues.usuario}
                            changeFunc={(selected) =>
                                setFormValues({ ...formValues, usuario: selected })
                            }
                        />
                        <FormComp
                            title="TIPO DE CHECKLIST"
                            type="multiselect"
                            placeholder="SELECIONE..."
                            options={tiposChecklist.map(obj => ({
                                value: obj.identifier,
                                label: obj.nome
                            }))}
                            mapped={true}
                            valor={formValues.tipoChecklist}
                            changeFunc={(selected) =>
                                setFormValues({ ...formValues, tipoChecklist: selected })
                            }
                        />
                        <FormComp
                            title="META SEMANAL"
                            type="number"
                            valor={formValues.metaSemanal}
                            changeFunc={(e) => setFormValues({ ...formValues, metaSemanal: e.target.value })}
                        />
                        <FormComp
                            type="submit"
                            valor={saving ? "SALVANDO..." : "SALVAR"}
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalAddMeta;